module.exports = __webpack_public_path__ + "img/trace-close.a83673dd.png";